import { createFileRoute, useParams } from '@tanstack/react-router'
import { OrgBrandIdentity } from '@/features/organizations/settings/org-brand-identity'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/settings/brand'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { orgId } = useParams({
    from: '/_authenticated/org/$orgId/settings/brand',
  })

  return <OrgBrandIdentity orgId={orgId} />
}
